import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Stack, Typography } from '@metarouter-private/mr-mui';

import FieldValueView from 'app/audit-logs/AuditLogModal/AuditLogPanel/FieldValueView';

export default function AuditLogComplexFieldRow({ field }) {
  return (
    <Grid container data-test-id="auditLogFieldRow" spacing={1}>
      <Grid item xs={4} data-test-id="auditLogFieldName">
        <Typography variant="body2">{field.label}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Stack spacing={0.5}>
          <FieldValueView fieldValue={field.current} complex />
          <Typography data-test-id="auditLogNotDiffedNote" variant="caption" color="text.secondary">
            Not diffed — the current value is shown; no previous value is compared.
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
}

AuditLogComplexFieldRow.propTypes = {
  field: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    complex: PropTypes.oneOf([true]).isRequired,
    current: PropTypes.object.isRequired,
  }).isRequired,
};
